<div class="editor-page">
  <lib-toastify-toast-container position="bottom-right"></lib-toastify-toast-container>

  <mat-toolbar class="editor-toolbar" color="primary">
    <button mat-icon-button (click)="cancel()" type="button">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1>{{ isUpdate ? 'Editar' : 'Criar' }} Diagnostic Question</h1>
    <span class="toolbar-spacer"></span>
    <button mat-stroked-button (click)="cancel()" [disabled]="saving">Cancelar</button>
    <button mat-raised-button color="accent" (click)="save()" [disabled]="saving || loading">
      <mat-spinner *ngIf="saving" diameter="20"></mat-spinner>
      <span *ngIf="!saving">{{ isUpdate ? 'Atualizar' : 'Criar' }}</span>
    </button>
  </mat-toolbar>

  <div class="loading-overlay" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>

  <div class="editor-shell" *ngIf="!loading" [formGroup]="metaForm">
    <!-- Meta: nome, CEFR, publicada -->
    <section class="meta-bar">
      <mat-form-field appearance="outline" class="meta-field meta-field--name">
        <mat-label>Nome</mat-label>
        <input matInput formControlName="name" (input)="onFieldChange()" />
      </mat-form-field>

      <mat-form-field appearance="outline" class="meta-field meta-field--cefr">
        <mat-label>CEFR</mat-label>
        <mat-select formControlName="cefr" (selectionChange)="onFieldChange()">
          <mat-option *ngFor="let c of cefrs" [value]="c">{{ c }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-slide-toggle formControlName="published" (change)="onFieldChange()" class="meta-published">
        Publicada
      </mat-slide-toggle>
    </section>

    <!-- Instrução (header) -->
    <div class="instruction-bar" [class.instruction-bar--invalid]="metaForm.get('instruction')?.invalid && metaForm.get('instruction')?.touched">
      <input
        class="instruction-input"
        formControlName="instruction"
        placeholder="Instrução da pergunta"
        (input)="onFieldChange()" />
    </div>

    <section class="question-section">
    <!-- Estímulo: imagem (esq), texto e áudio (dir, empilhados) -->
    <div class="stimulus-grid"
         [class.stimulus-grid--invalid]="isStimulusInvalid() || isStimulusImageInvalid()">

      <div class="stimulus-region stimulus-region--image" [class.stimulus-region--invalid]="isStimulusImageInvalid()">
        <div class="region-toolbar">
          <span class="region-label">Imagem</span>
          <button mat-icon-button type="button" class="clear-btn"
            *ngIf="hasStimulusImageContent()"
            (click)="clearStimulusImage()" title="Limpar imagem">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <mat-form-field appearance="outline" class="inline-field inline-field--compact">
          <mat-label>Image ID</mat-label>
          <input matInput [(ngModel)]="stimulusImageId" [ngModelOptions]="{standalone: true}"
            (ngModelChange)="stimulusImageIdChange($event)" />
        </mat-form-field>
        <button mat-stroked-button type="button" class="verify-btn" (click)="verifyStimulusImage()">
          Verificar imagem
        </button>
        <app-image-uploader *ngIf="stimulusImageToVerify"
          [imageId]="stimulusImageVerify"
          (exists)="onStimulusImageExists($event)"
          (uploadFiles)="onStimulusImageFile($event)">
        </app-image-uploader>
      </div>

      <div class="stimulus-content-column">
      <div class="stimulus-region stimulus-region--text">
        <div class="region-toolbar">
          <span class="region-label">Texto</span>
          <button mat-icon-button type="button" class="clear-btn"
            *ngIf="hasStimulusTextContent()"
            (click)="clearStimulusText()" title="Limpar texto">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <textarea
          class="stimulus-text-input"
          [(ngModel)]="stimulusText"
          [ngModelOptions]="{standalone: true}"
          (ngModelChange)="onFieldChange()"
          placeholder="Texto do estímulo"
          rows="3"></textarea>
      </div>

      <div class="stimulus-region stimulus-region--audio">
        <div class="region-toolbar">
          <span class="region-label">Áudio</span>
          <button mat-icon-button type="button" class="clear-btn"
            *ngIf="hasStimulusAudioContent()"
            (click)="clearStimulusAudio()" title="Limpar áudio">
            <mat-icon>close</mat-icon>
          </button>
        </div>
        <div *ngIf="generatingStimulusTts" class="tts-loading">
          <mat-spinner diameter="32"></mat-spinner>
          <span>A gerar áudio...</span>
        </div>

        <div *ngIf="stimulusAudioUrl && !generatingStimulusTts" class="tts-audio-row">
          <audio [src]="stimulusAudioUrl" controls class="audio-player"></audio>
          <button mat-icon-button type="button" class="tts-reset-btn"
            (click)="resetStimulusTts()" title="Remover áudio">
            <mat-icon>delete</mat-icon>
          </button>
        </div>

        <ng-container *ngIf="!stimulusAudioUrl && !generatingStimulusTts">
          <div class="voice-selector-row">
            <mat-form-field appearance="outline" class="inline-field voice-select-field">
              <mat-label>Voz</mat-label>
              <mat-select [(ngModel)]="stimulusAudioVoice" [ngModelOptions]="{standalone: true}">
                <mat-option *ngFor="let voice of googleVoices" [value]="voice">{{ voice }}</mat-option>
              </mat-select>
            </mat-form-field>
            <button mat-icon-button type="button" class="voice-preview-btn"
              (click)="playVoicePreview(stimulusAudioVoice)" title="Pré-visualizar voz">
              <mat-icon>play_arrow</mat-icon>
            </button>
          </div>
          <mat-form-field appearance="outline" class="inline-field">
            <mat-label>Texto para TTS</mat-label>
            <textarea matInput rows="2" [(ngModel)]="stimulusAudioTtsText" [ngModelOptions]="{standalone: true}"></textarea>
          </mat-form-field>
          <div class="tts-actions-row">
            <mat-slide-toggle [(ngModel)]="stimulusAudioTtsOverride" [ngModelOptions]="{standalone: true}">
              Regenerar áudio
            </mat-slide-toggle>
            <button mat-raised-button color="primary" type="button" (click)="generateStimulusTts()">
              Gerar áudio
            </button>
          </div>
        </ng-container>
      </div>
      </div>
    </div>

    <p class="field-error" *ngIf="isStimulusInvalid()">Preencha pelo menos um bloco de estímulo (texto, áudio ou imagem)</p>
    <p class="field-error" *ngIf="isStimulusImageInvalid()">Verifique ou envie a imagem do estímulo</p>
    </section>

    <!-- Alternativas -->
    <section class="options-section">
      <div class="options-toolbar">
        <div class="option-type-icons">
          <button mat-icon-button type="button"
            [class.active]="optionContentType === 'text'"
            (click)="setOptionContentType('text')"
            matTooltip="Texto"
            title="Texto">
            <mat-icon>text_fields</mat-icon>
          </button>
          <button mat-icon-button type="button"
            [class.active]="optionContentType === 'audio'"
            (click)="setOptionContentType('audio')"
            matTooltip="Áudio"
            title="Áudio">
            <mat-icon>volume_up</mat-icon>
          </button>
          <button mat-icon-button type="button"
            [class.active]="optionContentType === 'image'"
            (click)="setOptionContentType('image')"
            matTooltip="Imagem"
            title="Imagem">
            <mat-icon>image</mat-icon>
          </button>
        </div>

        <mat-slide-toggle [(ngModel)]="multipleCorrectAnswers" [ngModelOptions]="{standalone: true}"
          (change)="onFieldChange()">
          Múltiplas respostas corretas
        </mat-slide-toggle>
      </div>

      <p class="field-error" *ngIf="isCorrectAnswerInvalid()">Marque pelo menos uma resposta correta</p>

      <div class="options-grid"
           [class.options-grid--text]="optionContentType === 'text'"
           [class.options-grid--audio]="optionContentType === 'audio'"
           [class.options-grid--image]="optionContentType === 'image'">

        <div class="option-slot"
             *ngFor="let opt of options; let i = index"
             [class.option-slot--correct]="opt.isCorrect"
             [class.option-slot--invalid]="isOptionInvalid(i)"
             [class.option-slot--empty]="isOptionEmpty(i)">

          <div class="option-slot-header">
            <span class="option-letter">{{ optionLetters[i] }}</span>
            <div class="option-slot-actions">
              <button mat-icon-button type="button" class="clear-btn"
                *ngIf="hasOptionContent(i)"
                (click)="clearOption(i)" title="Limpar opção">
                <mat-icon>close</mat-icon>
              </button>
              <button mat-icon-button type="button" (click)="toggleOptionCorrect(i)"
                [class.correct-btn]="opt.isCorrect" title="Resposta correta">
                <mat-icon>check_circle</mat-icon>
              </button>
            </div>
          </div>

          <div class="option-slot-body">
            <ng-container *ngIf="optionContentType === 'text'">
              <input
                class="option-text-input"
                [(ngModel)]="opt.text"
                [ngModelOptions]="{standalone: true}"
                (ngModelChange)="onFieldChange()"
                [placeholder]="'Opção ' + optionLetters[i]" />
            </ng-container>

            <ng-container *ngIf="optionContentType === 'audio'">
              <div *ngIf="optionTtsLoading[i]" class="tts-loading tts-loading--compact">
                <mat-spinner diameter="24"></mat-spinner>
              </div>

              <div *ngIf="opt.audioUrl && !optionTtsLoading[i]" class="tts-audio-row">
                <audio [src]="opt.audioUrl" controls class="audio-player"></audio>
                <button mat-icon-button type="button" class="tts-reset-btn"
                  (click)="resetOptionTts(i)" title="Remover áudio">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>

              <ng-container *ngIf="!opt.audioUrl && !optionTtsLoading[i]">
                <div class="voice-selector-row voice-selector-row--compact">
                  <mat-form-field appearance="outline" class="inline-field voice-select-field">
                    <mat-label>Voz</mat-label>
                    <mat-select [(ngModel)]="opt.audioVoice" [ngModelOptions]="{standalone: true}">
                      <mat-option *ngFor="let voice of googleVoices" [value]="voice">{{ voice }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <button mat-icon-button type="button" class="voice-preview-btn"
                    (click)="playVoicePreview(opt.audioVoice)" title="Pré-visualizar voz">
                    <mat-icon>play_arrow</mat-icon>
                  </button>
                </div>
                <mat-form-field appearance="outline" class="inline-field">
                  <mat-label>TTS</mat-label>
                  <input matInput [(ngModel)]="opt.audioTtsText" [ngModelOptions]="{standalone: true}" />
                </mat-form-field>
                <div class="tts-actions-row tts-actions-row--compact">
                  <mat-slide-toggle [(ngModel)]="opt.audioTtsOverride" [ngModelOptions]="{standalone: true}">
                    Regenerar
                  </mat-slide-toggle>
                  <button mat-stroked-button type="button" (click)="generateOptionTts(i)">Gerar</button>
                </div>
              </ng-container>
            </ng-container>

            <ng-container *ngIf="optionContentType === 'image'">
              <mat-form-field appearance="outline" class="inline-field">
                <mat-label>Image ID</mat-label>
                <input matInput [(ngModel)]="opt.imageId" [ngModelOptions]="{standalone: true}"
                  (ngModelChange)="optionImageIdChange(i, $event)" />
              </mat-form-field>
              <button mat-stroked-button type="button" class="verify-btn" (click)="verifyOptionImage(i)">
                Verificar
              </button>
              <app-image-uploader *ngIf="opt.imageToVerify"
                [imageId]="opt.imageVerify"
                (exists)="onOptionImageExists(i, $event)"
                (uploadFiles)="onOptionImageFile(i, $event)">
              </app-image-uploader>
            </ng-container>
          </div>

          <p class="field-error field-error--inline" *ngIf="isOptionInvalid(i)">
            {{ getOptionErrorMessage(i) }}
          </p>
        </div>
      </div>
    </section>
  </div>
</div>
